export default __webpack_public_path__ + "static/media/CallOn.1cac6df5.svg";